import { Component, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { Globals } from 'src/app/shared/globals/globals';
import { EnquiryByEnquiryNo } from 'src/app/shared/models/data/enquiryByEnquiryNo.model';
import { Customer } from 'src/app/shared/models/data/headerParametersValues.model';
import { NormGrade } from 'src/app/shared/models/data/normGrades.model';
import { SelectOption } from 'src/app/shared/teiasoft-bucket/teiasoft-select/teiasoft-select.component';

@Component({
  selector: 'app-form-enquiry',
  templateUrl: './form-enquiry.component.html',
  styleUrls: ['./form-enquiry.component.scss']
})

export class FormEnquiryComponent implements OnInit, OnChanges {

  @Input() action: string = "";
  @Input() enquiryByEnquiryNo: EnquiryByEnquiryNo = new EnquiryByEnquiryNo();
  @Input() isMobile: boolean = false;
  @Input() customerList: Customer[] = new Array();
  @Input() mstOfferStatusList: SelectOption[] = new Array();
  @Input() unitSystemList: SelectOption[] = new Array();
  @Input() salesOfficeList: SelectOption[] = new Array();
  @Input() smsList: SelectOption[] = new Array();
  @Input() alloySurchargeList: SelectOption[] = new Array();
  @Input() orderReasonList: SelectOption[] = new Array();
  @Input() marketFamilyList: SelectOption[] = new Array();
  @Input() normGradesDataSet: NormGrade[] = new Array();
  @Input() rawMaterialGradeList: SelectOption[] = new Array();

  customerIsValid: boolean = true;
  offerStatusValid: boolean = true;
  dueDateValid:boolean = true;
  smsValid:boolean = true;
  alloySurchargeValid:boolean = true;
  marketFamilyValid:boolean = true;
  normGradesValid:boolean = true;

  constructor(public globals: Globals){}

  ngOnInit(): void {
   
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes["action"]){
      this.action = changes["action"].currentValue;
    }

    if (changes && changes["enquiryByEnquiryNo"]){
      this.enquiryByEnquiryNo = new EnquiryByEnquiryNo();
      this.enquiryByEnquiryNo = JSON.parse(JSON.stringify(changes["enquiryByEnquiryNo"].currentValue));
    }

    if (changes && changes["customerList"]){
      this.customerList = new Array();
      this.customerList = JSON.parse(JSON.stringify(changes["customerList"].currentValue));
    }

    if (changes && changes["mstOfferStatusList"]){
      this.mstOfferStatusList = new Array();
      this.mstOfferStatusList = JSON.parse(JSON.stringify(changes["mstOfferStatusList"].currentValue));
    }

    if (changes && changes["unitSystemList"]){
      this.unitSystemList = new Array();
      this.unitSystemList = JSON.parse(JSON.stringify(changes["unitSystemList"].currentValue));
    }

    if (changes && changes["salesOfficeList"]){
      this.salesOfficeList = new Array();
      this.salesOfficeList = JSON.parse(JSON.stringify(changes["salesOfficeList"].currentValue));
    }

    if (changes && changes["smsList"]){
      this.smsList = new Array();
      this.smsList = JSON.parse(JSON.stringify(changes["smsList"].currentValue));
    }

    if (changes && changes["alloySurchargeList"]){
      this.alloySurchargeList = new Array();
      this.alloySurchargeList = JSON.parse(JSON.stringify(changes["alloySurchargeList"].currentValue));
    }

    if (changes && changes["orderReasonList"]){
      this.orderReasonList = new Array();
      this.orderReasonList = JSON.parse(JSON.stringify(changes["orderReasonList"].currentValue));
    }

    if (changes && changes["marketFamilyList"]){
      this.marketFamilyList = new Array();
      this.marketFamilyList = JSON.parse(JSON.stringify(changes["marketFamilyList"].currentValue));
    }

    if (changes && changes["normGradesDataSet"]){
      this.normGradesDataSet = new Array();
      this.normGradesDataSet = JSON.parse(JSON.stringify(changes["normGradesDataSet"].currentValue));
    }

    if (changes && changes["rawMaterialGradeList"]){
      this.rawMaterialGradeList = new Array();
      this.rawMaterialGradeList = JSON.parse(JSON.stringify(changes["rawMaterialGradeList"].currentValue));
    }
  }

  //#region CUSTOMER
  onAutocompleteCustomerLinkClick(evt: any){
    // OPEN DUMMY CUSTOMER
  }

  onAutocompleteSelectCustomer(evt:any){
    // SELECT OF CUSTOMER
  }

  onAutocompleteCustomerInputChange(evt:any){
    // INPUT ON AUTOCOMPLETE
  }
  //#endregion

  //#region OFFER STATUS
  onSelectedOfferStatus(evt: SelectOption){

  }
  //#endregion

  //#region UnitSystem
  onSelectedUnitSystem(evt: SelectOption){

  }
  //#endregion

  //#region DueDate
  onChangeDueDate(evt:any){

  }
  //#endregion

  //#region SalesOffice
  onSelectedSalesOffice(evt:SelectOption){

  }

  getSalesOfficeValue(salesOffice: string): any{
    return this.salesOfficeList.filter(x => x.text == salesOffice)[0].value;
  }
  //#endregion

  //#region SMS
  onSelectedSms(evt: SelectOption){

  }

  getSmsValue(smsName: string): any{
    return this.smsList.filter(x => x.text == smsName)[0].value;
  }
  //#endregion

  //#region AlloySurcharge
  onSelectedAlloySurcharge(evt:SelectOption) {

  }
  //#endregion

  //#region OrderReason
  onSelectedOrderReason(evt:SelectOption){

  }
  //#endregion

  //#region NormGrades
  onAutocompleteSelectNormGrade(evt: any){

  }

  onAutocompleteNormGradeInputChange(evt: any){

  }

  getNormGrades(): any[]{
    return this.enquiryByEnquiryNo.enquiry!.normGrades!.map(x => x.normGradeCode);
  }
  //#endregion

  //#region RawMaterialGrade
  onSelectedRawMaterial(evt: SelectOption){
    
  }
  //#endregion
}
